import Alpine from "alpinejs";
import filter, {
    Filters,
} from "DistributionPackages/JvMTECH.Components/Resources/Private/Fusion/Organism/Filter/Filter";

Alpine.data("JobGrid", (filters: Filters) => ({
    ...filter(filters, true),
}));
